<template>
  <div class="login-container">
    <div class="login-wrapper">
      <div class="user-login">
        <template v-if="!authStore.isCheckingAuth">
          <template v-if="authStore.isAuthenticated">
            <a href="javascript:void(0)" class="logout-btn">
              <div class="user-info">
                <!-- <span class="welcome">欢迎，{{ authStore.user?.nickName || authStore.user?.tel || authStore.user?.email
                  }}</span> -->
                <!-- <i class="iconfont">&#xe65e;</i> -->
                 <div class="avatar-img">
                    <img :src="avatarPath" alt="用户头像" />
                </div>
              </div>
              <div class="login-drop" style="display: none;">
                <div class="login-drop-inner">
                  <a href="/account/edit" target="_blank">
                    <div class="avatar-img">
                      <img :src="avatarPath" alt="用户头像" />
                    </div>我的账户</a>
                  <a href="/home2" target="_blank"><i class="iconfont">&#xe69d;</i>我的课程</a>
                  <a @click="handleLogout"><i class="iconfont">&#xe69e;</i>退出登录</a>
                </div>
              </div>
            </a>
          </template>
          <template v-else>
            <ola-button 
              size="lg" 
              round 
              class="login-register-btn"
              :style="loginButtonStyle"
              @click="showLoginModal"
            >
              登录/注册
            </ola-button>
          </template>
        </template>
      </div>
    </div>

    <!-- 登录/注册弹窗 -->
    <div class="login-modal" v-if="isModalVisible" :style="loginModalStyle">
      <div class="login-modal-content">
        <!-- 右上角关闭按钮 -->
        <div class="close-btn" @click="closeModal">
          <span class="iconfont">&#xeaf2;</span>
        </div>

        <!-- 标题 -->
        <div class="modal-title-content">
          <h2 class="modal-title"
            v-if="activeTab !== 'forgot' && activeTab !== 'resetPassword' && activeTab !== 'completeProfile'">登录欧那账号
          </h2>
          <h2 class="modal-title" v-else-if="activeTab === 'forgot'">修改密码</h2>
          <h2 class="modal-title" v-else-if="activeTab === 'resetPassword'">重置密码</h2>
          <h2 class="modal-title" v-else-if="activeTab === 'completeProfile'">完善个人信息</h2>
          <div class="modal-sub-title-wrap">
            <p class="modal-sub-title"
              v-if="activeTab !== 'forgot' && activeTab !== 'resetPassword' && activeTab !== 'completeProfile' && activeTab !== 'password'">
              未注册手机号，完成验证即可注册并登录
            </p>
          </div>
          <p class="modal-sub-title" v-if="activeTab === 'completeProfile'">完善信息即可登录成功</p>
        </div>

        <!-- 切换标签 -->
        <div class="tab-container"
          v-if="activeTab !== 'forgot' && activeTab !== 'resetPassword' && activeTab !== 'completeProfile'">
          <div class="tab" :class="{ active: activeTab === 'phone' }" @click="activeTab = 'phone'">
            验证码登录
            <div class="tab-underline" v-if="activeTab === 'phone'"></div>
          </div>
          <div class="tab" :class="{ active: activeTab === 'password' }" @click="activeTab = 'password'">
            密码登录
            <div class="tab-underline" v-if="activeTab === 'password'"></div>
          </div>
        </div>

        <!-- 忘记密码步骤指示器 -->
        <div class="steps-container" v-if="activeTab === 'forgot' || activeTab === 'resetPassword'">
          <div class="step-item" :class="{ active: activeTab === 'forgot' }">
            <div class="step-number" v-if="activeTab === 'forgot'">1</div>
            <div class="step-number iconfont" v-else>&#xe633;</div>
            <div class="step-label" :class="{ 'second': activeTab !== 'forgot' }">手机/邮箱验证</div>
          </div>
          <div class="line"></div>
          <div class="step-item" :class="{ active: activeTab === 'resetPassword' }">
            <div class="step-number">2</div>
            <div class="step-label">重置密码</div>
          </div>
        </div>

        <!-- 手机验证码登录表单 -->
        <div v-if="activeTab === 'phone'" class="login-form">
          <div class="input-group">
            <input type="text" placeholder="请输入手机号" v-model="phoneNumber" />
            <div class="error-message" v-if="errors.phoneNumber">{{ errors.phoneNumber }}</div>
          </div>

          <div class="input-group">
            <div class="verification-code">
              <input type="text" placeholder="请输入验证码" v-model="verificationCode" />
              <button class="verification-btn" :disabled="isSendCodeLoading || countdown > 0"
                @click="sendVerificationCode">
                {{ countdown > 0 ? `重新发送 ${countdown}秒` : '获取验证码' }}
              </button>
            </div>
            <div class="error-message" v-if="errors.verificationCode">{{ errors.verificationCode }}</div>
          </div>

          <button class="login-submit" @click="handleLogin" :disabled="isLoginLoading">立即登录/注册</button>
          <div class="terms-agreement">
            <div class="agreement-content">
              <input type="checkbox" id="agreeTerms" v-model="agreeTerms" />
              <label for="agreeTerms">我已阅读并同意<a href="#" class="term-link"
                  @click.prevent="openAgreementModal('user')"> 使用协议</a> 及 <a href="#" class="term-link"
                  @click.prevent="openAgreementModal('privacy')"> 隐私政策</a></label>
            </div>
            <div class="error-message" v-if="errors.agreement">{{ errors.agreement }}</div>
            <div class="agreement-tooltip" v-if="showAgreementTooltip">
              请阅读并勾选协议
              <div class="tooltip-arrow"></div>
            </div>

          </div>
          <div class="other-login">
            <div class="other-login-title">其他方式登录</div>
            <a :href="weixinLoginUrl" target="_blank" class="iconfont">&#xe600;</a>
          </div>
        </div>

        <!-- 账号密码登录表单 -->
        <div v-if="activeTab === 'password'" class="login-form">
          <div class="input-group">
            <input type="text" placeholder="请输入账号" v-model="username" />
            <div class="error-message" v-if="errors.username">{{ errors.username }}</div>
          </div>

          <div class="input-group">
            <div class="flex-div">
              <input :type="showPassword ? 'text' : 'password'" placeholder="请输入密码" v-model="password" />
              <span class="toggle-password" @click="showPassword = !showPassword">
                <i class="iconfont" v-if="!showPassword">&#xe7a6;</i>
                <i class="iconfont" v-else>&#xe6aa;</i>
              </span>
            </div>
            <div class="error-message" v-if="errors.password">{{ errors.password }}</div>
          </div>

          <button class="login-submit" @click="handlePasswordLogin" :disabled="isPasswordLoginLoading">立即登录</button>
          <div class="terms-agreement">
            <div class="agreement-content">
              <input type="checkbox" id="agreeTerms2" v-model="agreeTerms" />
              <label for="agreeTerms2">我已阅读并同意<a href="#" class="term-link"
                  @click.prevent="openAgreementModal('user')"> 使用协议</a> 及 <a href="#" class="term-link"
                  @click.prevent="openAgreementModal('privacy')"> 隐私政策</a></label>
            </div>
            <span @click="forgotPassword(username)" class="forget-password">忘记密码</span>
            <div class="error-message" v-if="errors.agreement">{{ errors.agreement }}</div>
            <div class="agreement-tooltip" v-if="showAgreementTooltip">
              请阅读并勾选协议
              <div class="tooltip-arrow"></div>
            </div>
          </div>
          <div class="other-login">
            <div class="other-login-title">其他方式登录</div>
            <a :href="weixinLoginUrl" target="_blank" class="iconfont">&#xe600;</a>
          </div>

        </div>

        <!-- 忘记密码第一步：手机/邮箱验证 -->
        <div v-if="activeTab === 'forgot'" class="login-form">
          <div class="input-group">
            <input type="text" placeholder="请输入手机号/邮箱" v-model="forgotData.account" />
            <div class="error-message" v-if="errors.account">{{ errors.account }}</div>
          </div>

          <div class="input-group">
            <div class="verification-code">
              <input type="text" placeholder="请输入验证码" v-model="forgotData.verificationCode" />
              <button class="verification-btn" :disabled="isForgotCodeLoading || forgotCountdown > 0"
                @click="sendForgotVerificationCode">
                {{ forgotCountdown > 0 ? `重新发送 ${forgotCountdown}秒` : '获取验证码' }}
              </button>
            </div>
            <div class="error-message" v-if="errors.verificationCode">{{ errors.verificationCode }}</div>
          </div>

          <button class="login-submit" @click="verifyForgotStep" :disabled="isForgotCheckLoading">下一步</button>
          <div class="return-login">
            <span @click="backToLogin">返回登录</span>
          </div>
        </div>

        <!-- 忘记密码第二步：重置密码 -->
        <div v-if="activeTab === 'resetPassword'" class="login-form">
          <div class="input-group">
            <div class="flex-div">
              <input :type="showNewPassword ? 'text' : 'password'" placeholder="请输入8-16位新密码"
                v-model="forgotData.newPassword" @blur="handleNewPasswordBlur" />
              <span class="toggle-password" @click="showNewPassword = !showNewPassword">
                <i class="iconfont" v-if="!showNewPassword">&#xe7a6;</i>
                <i class="iconfont" v-else>&#xe6aa;</i>
              </span>
            </div>
            <div class="error-message" v-if="errors.newPassword">{{ errors.newPassword }}</div>
          </div>

          <div class="input-group">
            <div class="flex-div">
              <input :type="showConfirmPassword ? 'text' : 'password'" placeholder="请再次输入8-16位新密码"
                v-model="forgotData.confirmPassword" @blur="handleConfirmPasswordBlur" />
              <span class="toggle-password" @click="showConfirmPassword = !showConfirmPassword">
                <i class="iconfont" v-if="!showConfirmPassword">&#xe7a6;</i>
                <i class="iconfont" v-else>&#xe6aa;</i>
              </span>
            </div>
            <div class="error-message" v-if="errors.confirmPassword">{{ errors.confirmPassword }}</div>
          </div>

          <button class="login-submit" @click="resetPassword" :disabled="isResetPwdLoading">确认修改</button>
          <div class="return-login">
            <span @click="backToLogin">返回登录</span>
          </div>
        </div>

        <!-- 完善个人信息表单 -->
        <div v-if="activeTab === 'completeProfile'" class="login-form">
          <div class="input-group">
            <input type="text" placeholder="请输入您的昵称" v-model="profileData.nickname" />
            <div class="error-message" v-if="errors.nickname">{{ errors.nickname }}</div>
          </div>

          <div class="input-group">
            <div class="flex-div">
              <input :type="showProfilePassword ? 'text' : 'password'" placeholder="请输入8-16位新密码"
                v-model="profileData.password" />
              <span class="toggle-password" @click="showProfilePassword = !showProfilePassword">
                <i class="iconfont" v-if="!showProfilePassword">&#xe7a6;</i>
                <i class="iconfont" v-else>&#xe6aa;</i>
              </span>
            </div>
            <div class="error-message" v-if="errors.profilePassword">{{ errors.profilePassword }}</div>
          </div>

          <button class="login-submit" @click="completeProfile" :disabled="isCompleteProfileLoading">完成</button>
          <div class="return-login">
            <span @click="backToLogin">返回登录</span>
          </div>
        </div>


      </div>
      <!-- 阿里云验证码挂载点 -->
      <div id="captcha-element"></div>
      <!-- 必须保证元素存在且具有一定物理尺寸，避免SDK内部报错 INIT_FAIL -->
      <div id="captcha-button" style="position: absolute; width: 1px; height: 1px; top: 50%; left: 50%; opacity: 0; pointer-events: none; z-index: -1;"></div>
    </div>

    <!-- 自定义提示框 -->
    <transition name="fade">
      <div class="custom-toast" v-if="toast.show" :class="toast.type">
        <span class="toast-icon iconfont" v-if="toast.type === 'success'">&#xe65b;</span>
        <span class="toast-icon iconfont" v-else-if="toast.type === 'error'">&#xeaf2;</span>
        <span class="toast-icon iconfont" v-else-if="toast.type === 'info'">&#xe8e5;</span>
        <span class="toast-message">{{ toast.message }}</span>
      </div>
    </transition>
    <!-- 协议弹窗 -->
    <div v-if="showAgreementModal" class="agreement-modal-mask" @click.self="closeAgreementModal">
      <div class="agreement-modal-content">
        <div class="agreement-modal-header">
          <span>{{ agreementTitle }}</span>
          <span class="agreement-modal-close iconfont" @click="closeAgreementModal">&#xeaf2;</span>
        </div>
        <div class="agreement-modal-body">
          <component v-if="agreementComponent" :is="agreementComponent" />
          <pre v-else style="white-space: pre-wrap;word-break: break-all;">{{ agreementTitle }}内容暂未提供</pre>
        </div>
      </div>
    </div>

    <!-- 弱密码提醒弹窗 -->
    <div v-if="showWeakPasswordModal" class="weak-password-modal-mask" @click.self="showWeakPasswordModal = false">
      <div class="weak-password-modal-content" :style="loginModalStyle">
        <div class="close-btn" @click="showWeakPasswordModal = false">
          <span class="iconfont">&#xeaf2;</span>
        </div>
        <div class="safe-icon">
          <img :src="getRootImagePath('safe.png')" alt="账户安全" />
        </div>
        <div class="safe-title">账户安全升级</div>
        <div class="safe-desc">您当前使用的密码安全等级较低，为保障您的课程与个人信息安全，建议立即修改为强度更高的密码。</div>
        <button class="safe-btn" @click="handleWeakPasswordReset">重置密码</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, defineAsyncComponent, computed, watch, onMounted, nextTick } from 'vue'
import { useAuthStore } from '@/stores/UserAuth.js'
import { useGlobalUIStore } from '@/stores/GlobalUI'
import { useSiteConfigStore } from '@/stores/SiteConfig'
import commonConfig from '@/configs/common'
import { setCookie } from '@/utils/Cookie.js'
import { getSiteConfigByProfile } from '@/utils/SiteConfig.js'
import { getImagePath, getRootImagePath } from '@/utils/ImageHelper';
import { loginByPassword, sendLoginCode, checkLoginCode, fillRegisterInfo, sendRecoverCode, checkRecoverCode, submitRecoverPassword, getUserInfoById, getCaptchaKey } from '@/service/user/AuthService.js'
import { isValidPhone, isValidEmail } from '@/utils/validate'
import { useCaptcha } from '@/hooks/useCaptcha.js'

// 初始化验证码 composable
const { requestCaptchaVerify, destroyCaptcha, isCaptchaLoading } = useCaptcha()

const curLanguage = `${__SITE_PROFILE__}`

// 获取站点配置
const siteConfigStore = useSiteConfigStore()

/**
 * 登录按钮主题色（可配置）
 * - 默认值：#FF1F59
 * - 德国站：#F93636（通过 headerMainColor 配置）
 */
const loginButtonColor = computed(() => {
    // 优先使用 headerMainColor，如果没有则使用默认值
    let color = siteConfigStore.headerMainColor || '#FF1F59'
    
    // 如果 store 中没有，尝试从 window.__INITIAL_SITE_CONFIG__ 获取
    if (!siteConfigStore.headerMainColor && typeof window !== 'undefined' && window.__INITIAL_SITE_CONFIG__) {
        color = window.__INITIAL_SITE_CONFIG__.headerMainColor || '#FF1F59'
        // 如果找到了，更新 store
        if (window.__INITIAL_SITE_CONFIG__.headerMainColor) {
            siteConfigStore.$patch({
                headerMainColor: window.__INITIAL_SITE_CONFIG__.headerMainColor
            })
        }
    }
    
    return color
})

/**
 * 登录按钮样式（动态颜色）
 */
const loginButtonStyle = computed(() => {
    return {
        '--login-button-color': loginButtonColor.value
    }
})

/**
 * 生成 hover 色（简单加深）
 * @param {string} hex 十六进制色值
 * @param {number} factor 加深系数（0-1，越小越深）
 * @returns {string} 十六进制色值
 */
const darkenHex = (hex, factor = 0.9) => {
    const raw = (hex || '').replace('#', '').trim()
    const full = raw.length === 3
        ? raw.split('').map(c => c + c).join('')
        : raw
    if (full.length !== 6) return '#E61A4F'
    const clamp = (v) => Math.max(0, Math.min(255, v))
    const r = clamp(Math.round(parseInt(full.slice(0, 2), 16) * factor))
    const g = clamp(Math.round(parseInt(full.slice(2, 4), 16) * factor))
    const b = clamp(Math.round(parseInt(full.slice(4, 6), 16) * factor))
    return `#${[r, g, b].map(n => n.toString(16).padStart(2, '0')).join('')}`
}

/**
 * 生成浅色背景（用于图标背景）
 * @param {string} hex 十六进制色值
 * @param {number} alpha 透明度（0-1）
 * @returns {string} rgba 色值
 */
const hexToRgba = (hex, alpha = 0.2) => {
    const raw = (hex || '').replace('#', '').trim()
    const full = raw.length === 3
        ? raw.split('').map(c => c + c).join('')
        : raw
    if (full.length !== 6) return `rgba(255, 31, 89, ${alpha})`
    const r = parseInt(full.slice(0, 2), 16)
    const g = parseInt(full.slice(2, 4), 16)
    const b = parseInt(full.slice(4, 6), 16)
    return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

/**
 * 登录弹窗样式（动态颜色）
 * 用于弹窗内所有需要动态颜色的元素
 */
const loginModalStyle = computed(() => {
    const color = loginButtonColor.value
    return {
        '--login-modal-primary-color': color,
        '--login-modal-primary-color-hover': darkenHex(color, 0.95),
        '--login-modal-primary-color-disabled': hexToRgba(color, 0.55),
        '--login-modal-primary-color-light-bg': hexToRgba(color, 0.2)
    }
})


// 使用Pinia状态管理保持登录状态
const authStore = useAuthStore()
const globalUI = useGlobalUIStore()
const isModalVisible = computed(() => globalUI.loginModalVisible)

/**
 * 用户头像路径
 * 优先使用用户返回的头像，没有则使用默认头像
 * 注意：登录接口返回 url，刷新页面 checkAuth 返回 imageUrl
 */
const avatarPath = computed(() => {
  // 如果用户已登录且有头像，使用用户头像（兼容 url 和 imageUrl 两个字段）
  if (authStore.user?.url) {
    return authStore.user.url
  }
  // 刷新页面时 checkAuth 返回的是 imageUrl 字段
  if (authStore.user?.imageUrl) {
    return authStore.user.imageUrl
  }
  // 否则使用默认头像
  return getImagePath(`/images/${curLanguage}/avatar.png`)
})

// 模态框显示状态
const activeTab = ref('phone') // 'phone', 'password', 'register', 'forgot', 'resetPassword', 'completeProfile'
const showAgreementTooltip = ref(false) // 添加协议提示框显示状态

// 表单数据
const phoneNumber = ref('')
watch(
  () => globalUI.loginModalPrefill,
  (val) => {
    if (globalUI.loginModalVisible && val) {
      phoneNumber.value = val
    }
  }
)

// 监听登录弹窗显示状态，更新微信登录链接
watch(
  () => isModalVisible.value,
  async (newVal) => {
    if (newVal) {
      await updateWeixinLoginUrl()
    }
  }
)
const verificationCode = ref('')
const username = ref('')
const password = ref('')
const showPassword = ref(false)
const agreeTerms = ref(false)
const countdown = ref(0)

// 完善个人信息表单数据
const profileData = reactive({
  nickname: '',
  password: '',
  phoneOrEmail: '' // 存储验证通过的手机号/邮箱
})
const showProfilePassword = ref(false)

// 忘记密码表单数据
const forgotData = reactive({
  account: '',
  verificationCode: '',
  newPassword: '',
  confirmPassword: '',
  recoverToken: '' // 新增找回密码token
})
const showNewPassword = ref(false)
const showConfirmPassword = ref(false)
const forgotCountdown = ref(0)

// 错误信息
const errors = reactive({
  account: '',
  verificationCode: '',
  newPassword: '',
  confirmPassword: '',
  phoneNumber: '',
  username: '',
  password: '',
  agreement: '',
  nickname: '',
  profilePassword: ''
})

// 注册表单数据
const registerPhone = ref('')
const registerVerificationCode = ref('')
const registerPassword = ref('')
const showRegisterPassword = ref(false)
const registerCountdown = ref(0)

// 弱密码弹窗状态
const showWeakPasswordModal = ref(false)
const handleWeakPasswordReset = () => {
  const currentAccount = username.value
  showWeakPasswordModal.value = false
  forgotPassword(currentAccount)
}

// 提示框状态
const toast = reactive({
  show: false,
  message: '',
  type: 'info', // 'info', 'success', 'error'
  timer: null
})

// 显示提示框
const showToast = (message, type = 'info', duration = 2000) => {
  // 如果已有提示框显示，先清除定时器
  if (toast.timer) {
    clearTimeout(toast.timer)
  }

  // 设置提示框内容和状态
  toast.message = message
  toast.type = type
  toast.show = true

  // 设置定时器，自动隐藏提示框
  toast.timer = setTimeout(() => {
    toast.show = false
  }, duration)
}



// 新增变量
const isFillInfo = ref(false)
const completeProfileToken = ref('')

// 防重复请求loading变量
const isSendCodeLoading = ref(false)
const isLoginLoading = ref(false)
const isPasswordLoginLoading = ref(false)
const isForgotCodeLoading = ref(false)
const isForgotCheckLoading = ref(false)
const isResetPwdLoading = ref(false)
const isCompleteProfileLoading = ref(false)

const weixinAppId = 'wx7227aeda3533cb89'
const weixinLoginUrl = ref('')
const weixinRequestHost = import.meta.env.PROD ? 'https://cas.olacio.com/weixin-login-code' : 'http://sso.rc.olacio.com/weixin-login-code';
async function getSchoolId() {
  const curLanguage = `${__SITE_PROFILE__}`
  const siteConfig = await getSiteConfigByProfile(curLanguage)
  return siteConfig.schoolId
}

const getWeixinLoginUrl = async () => {
  const schoolId = await getSchoolId()
  const referrer = window.location.href;
  return `${weixinRequestHost}?weixin-app-id=${weixinAppId}&school-id=${schoolId}&referrer=${referrer}`
}

const updateWeixinLoginUrl = async () => {
  weixinLoginUrl.value = await getWeixinLoginUrl()
}

// 显示登录模态框
const showLoginModal = async () => {
  globalUI.openLoginModal()
  // 重置表单
  phoneNumber.value = ''
  verificationCode.value = ''
  username.value = ''
  password.value = ''
  agreeTerms.value = false
  activeTab.value = 'phone'
  await updateWeixinLoginUrl()
}

// 关闭模态框
const closeModal = () => {
  globalUI.closeLoginModal()
  // 重置错误信息
  Object.keys(errors).forEach(key => {
    errors[key] = ''
  })
}

// 切换到注册页面
const switchToRegister = () => {
  activeTab.value = 'register'
  registerPhone.value = ''
  registerVerificationCode.value = ''
  registerPassword.value = ''
}

// 忘记密码
const forgotPassword = (prefillAccount = '') => {
  activeTab.value = 'forgot'
  // 重置忘记密码表单
  forgotData.account = prefillAccount
  forgotData.verificationCode = ''
  forgotData.newPassword = ''
  forgotData.confirmPassword = ''
  forgotData.recoverToken = '' // 重置找回token
  // 重置错误信息
  Object.keys(errors).forEach(key => {
    errors[key] = ''
  })
}

// 返回登录页面
const backToLogin = () => {
  activeTab.value = 'password'
  // 重置错误信息
  Object.keys(errors).forEach(key => {
    errors[key] = ''
  })
}

// 发送忘记密码验证码
const sendForgotVerificationCode = async () => {
  if (isForgotCodeLoading.value) return
  isForgotCodeLoading.value = true
  errors.account = ''
  errors.verificationCode = ''
  if (!forgotData.account) {
    errors.account = '账号不能为空'
    isForgotCodeLoading.value = false
    return
  }
  if (!isValidPhone(forgotData.account) && !isValidEmail(forgotData.account)) {
    errors.account = '请输入正确的手机号或邮箱'
    isForgotCodeLoading.value = false
    return
  }
  try {
    const res = await sendRecoverCode({ account: forgotData.account })
    if (res.code === 1) {
      forgotCountdown.value = 60
      const timer = setInterval(() => {
        forgotCountdown.value--
        if (forgotCountdown.value <= 0) clearInterval(timer)
      }, 1000)
      showToast('验证码已发送', 'success')
    } else {
      errors.account = res.message || '发送失败'
    }
  } catch (e) {
    errors.account = e?.response?.data?.message || '发送失败'
  } finally {
    isForgotCodeLoading.value = false
  }
}
// 验证忘记密码第一步
const verifyForgotStep = async () => {
  if (isForgotCheckLoading.value) return
  isForgotCheckLoading.value = true
  errors.account = ''
  errors.verificationCode = ''
  if (!forgotData.account) {
    errors.account = '账号不能为空'
    isForgotCheckLoading.value = false
    return
  }
  if (!isValidPhone(forgotData.account) && !isValidEmail(forgotData.account)) {
    errors.account = '请输入正确的手机号或邮箱'
    isForgotCheckLoading.value = false
    return
  }
  if (!forgotData.verificationCode) {
    errors.verificationCode = '请输入验证码'
    isForgotCheckLoading.value = false
    return
  }
  try {
    const res = await checkRecoverCode({ account: forgotData.account, verifyCode: forgotData.verificationCode })
    if (res.code === 1) {
      // 存储找回token
      forgotData.recoverToken = res.data.token
      activeTab.value = 'resetPassword'
    } else {
      errors.verificationCode = res.message || '验证码校验失败'
    }
  } catch (e) {
    errors.verificationCode = e?.response?.data?.message || '验证码校验失败'
  } finally {
    isForgotCheckLoading.value = false
  }
}
// 新增：处理新密码输入框失焦事件
const handleNewPasswordBlur = () => {
  if (forgotData.newPassword && (forgotData.newPassword.length < 8 || forgotData.newPassword.length > 16)) {
    errors.newPassword = '密码长度应为8-16位'
  } else {
    errors.newPassword = ''
  }
  // 如果确认密码不为空，则重新校验
  if (forgotData.confirmPassword) {
    handleConfirmPasswordBlur()
  }
}

// 新增：处理确认密码输入框失焦事件
const handleConfirmPasswordBlur = () => {
  if (forgotData.confirmPassword && (forgotData.confirmPassword.length < 8 || forgotData.confirmPassword.length > 16)) {
    errors.confirmPassword = '密码长度应为8-16位'
  } else if (forgotData.confirmPassword && forgotData.newPassword !== forgotData.confirmPassword) {
    errors.confirmPassword = '两次输入的密码不一致'
  } else {
    errors.confirmPassword = ''
  }
}
// 重置密码
const resetPassword = async () => {
  if (isResetPwdLoading.value) return
  isResetPwdLoading.value = true
  errors.newPassword = ''
  errors.confirmPassword = ''
  if (!forgotData.newPassword) {
    errors.newPassword = '请输入新密码'
    isResetPwdLoading.value = false
    return
  }
  if (forgotData.newPassword.length < 8 || forgotData.newPassword.length > 16) {
    errors.newPassword = '密码长度应为8-16位'
    isResetPwdLoading.value = false
    return
  }
  if (!forgotData.confirmPassword) {
    errors.confirmPassword = '请再次输入新密码'
    isResetPwdLoading.value = false
    return
  }
  if (forgotData.newPassword !== forgotData.confirmPassword) {
    errors.confirmPassword = '两次输入的密码不一致'
    isResetPwdLoading.value = false
    return
  }
  try {
    const res = await submitRecoverPassword({ token: forgotData.recoverToken, password: forgotData.newPassword, confirmPassword: forgotData.confirmPassword })
    if (res.code === 1) {
      showToast('密码修改成功', 'success')
      setTimeout(() => { activeTab.value = 'password' }, 1000)
    } else {
      errors.confirmPassword = res.message || '重置失败'
    }
  } catch (e) {
    errors.confirmPassword = e?.response?.data?.message || '重置失败'
  } finally {
    isResetPwdLoading.value = false
  }
}
// 发送验证码（集成 captcha 防刷机制）
const sendVerificationCode = async () => {
  if (isSendCodeLoading.value) return
  isSendCodeLoading.value = true
  errors.phoneNumber = ''
  errors.verificationCode = ''
  // 协议勾选判断
  if (!agreeTerms.value) {
    showAgreementTooltip.value = true
    setTimeout(() => { showAgreementTooltip.value = false }, 3000)
    isSendCodeLoading.value = false
    return
  }
  if (!phoneNumber.value) {
    errors.phoneNumber = '请输入手机号'
    isSendCodeLoading.value = false
    return
  }
  if (!isValidPhone(phoneNumber.value)) {
    errors.phoneNumber = '请输入正确的手机号'
    isSendCodeLoading.value = false
    return
  }
  try {
    // 第一步：获取 captchaKey 及是否需要 captcha 验证
    const captchaRes = await getCaptchaKey()
    if (captchaRes.code !== 1) {
      errors.phoneNumber = captchaRes.message || '获取验证信息失败'
      isSendCodeLoading.value = false
      return
    }
    const { captchaKey, verified } = captchaRes.data
    let captchaMessage = undefined

    // 第二步：如果需要 captcha 验证（verified=true），弹出阿里云滑块验证
    if (verified) {
      // 关键修改：在等待用户滑块验证期间，解除按钮锁定，允许用户后续可以重新点击触发
      isSendCodeLoading.value = false
      try {
        captchaMessage = await requestCaptchaVerify(captchaKey)
        // 验证完成后，继续重新锁定按钮状态防止连点提交接口
        isSendCodeLoading.value = true
      } catch (captchaErr) {
        errors.phoneNumber = captchaErr?.message || '验证码校验失败，请重试'
        isSendCodeLoading.value = false
        return
      }
    }

    // 第三步：调用发送验证码接口，携带 captchaKey 和 captchaMessage
    const res = await sendLoginCode({
      tel: phoneNumber.value,
      registerPlace: globalUI.registerPlace || 'Head',
      captchaKey,
      captchaMessage,
    })
    if (res.code === 1) {
      countdown.value = 60
      const timer = setInterval(() => {
        countdown.value--
        if (countdown.value <= 0) clearInterval(timer)
      }, 1000)
      showToast('验证码已发送', 'success')
      // 记录fillInfo
      isFillInfo.value = !!(res.data && res.data.fillInfo)
    } else if (res.code === 1024 || res.code === 1025) {
      // 1024: captcha验证失败，1025: captchaKey 过期
      // 均需要销毁当前实例并重新发起整个验证流程
      errors.phoneNumber = res.code === 1024 ? 'captcha验证失败，请重新滑动验证码' : '验证已过期，请重新滑动验证码'
      destroyCaptcha()
      isSendCodeLoading.value = false
      // 自动重新发起验证码流程
      setTimeout(() => {
        sendVerificationCode()
      }, 500)
    } else {
      errors.phoneNumber = res.message || '发送失败'
      isFillInfo.value = false
    }
  } catch (e) {
    const errCode = e?.response?.data?.code
    if (errCode === 1024 || errCode === 1025) {
      errors.phoneNumber = errCode === 1024 ? 'captcha验证失败，请重新滑动验证码' : '验证已过期，请重新滑动验证码'
      destroyCaptcha()
      isSendCodeLoading.value = false
      setTimeout(() => {
        sendVerificationCode()
      }, 500)
    } else {
      errors.phoneNumber = e?.response?.data?.message || '发送失败'
    }
    isFillInfo.value = false
  } finally {
    // 只有在非 1024 和 1025 (即成功或其他完全失败的情况) 下才在此处清理 Loading
    // 否则在 setTimeout 前会被意外重置
    if (![1024, 1025].includes(errors.phoneNumber.includes('captcha验证') ? 1024 : 0)) {
       destroyCaptcha()
       isSendCodeLoading.value = false
    }
  }
}
// 处理手机验证码登录
const handleLogin = async () => {
  if (isLoginLoading.value) return
  isLoginLoading.value = true
  errors.phoneNumber = ''
  errors.verificationCode = ''
  errors.agreement = ''
  showAgreementTooltip.value = false
  if (!agreeTerms.value) {
    showAgreementTooltip.value = true
    setTimeout(() => { showAgreementTooltip.value = false }, 3000)
    isLoginLoading.value = false
    return
  }
  if (!phoneNumber.value) {
    errors.phoneNumber = '请输入手机号/邮箱'
    isLoginLoading.value = false
    return
  }
  if (!isValidPhone(phoneNumber.value) && !isValidEmail(phoneNumber.value)) {
    errors.phoneNumber = '请输入正确的手机号或邮箱'
    isLoginLoading.value = false
    return
  }
  if (!verificationCode.value) {
    errors.verificationCode = '请输入验证码'
    isLoginLoading.value = false
    return
  }
  try {
    const res = await checkLoginCode({ tel: phoneNumber.value, verifyCode: verificationCode.value })
    if (res.code === 1 && res.data && res.data.token) {
      completeProfileToken.value = res.data.token
      setCookie(commonConfig.authTokenName, res.data.token, {
        path: '/',
        expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
      })
      // 查询用户信息，获取所有字段
      let userInfo = {}
      try {
        const userInfoRes = await getUserInfoById(res.data.userId)
        if (userInfoRes.code === 1 && userInfoRes.data) {
          userInfo = userInfoRes.data
        }
      } catch (e) { }
      // 设置Pinia状态，存所有userInfo字段
      authStore.setAuth({ userId: res.data.userId, schoolId: res.data.schoolId, ...userInfo }, res.data.token)

      if (isFillInfo.value) {
        profileData.phoneOrEmail = phoneNumber.value
        activeTab.value = 'completeProfile'
      } else if (res.code === 1 && res.data && res.data.token) {
        let userInfo = {}
        try {
          const userInfoRes = await getUserInfoById(res.data.userId)
          if (userInfoRes.code === 1 && userInfoRes.data) {
            userInfo = userInfoRes.data
          }
        } catch (e) { }
        authStore.setAuth({ userId: res.data.userId, schoolId: res.data.schoolId, ...userInfo }, res.data.token)
        showToast('登录成功', 'success')
        setTimeout(() => { closeModal() }, 500)
      } else {
        errors.verificationCode = res.message || '登录失败'
      }

    } else {
      errors.verificationCode = res.message || '验证码校验失败'
    }

  } catch (e) {
    errors.verificationCode = e?.response?.data?.message || '登录失败'
  } finally {
    isLoginLoading.value = false
  }
}
// 处理账号密码登录
const handlePasswordLogin = async () => {
  if (isPasswordLoginLoading.value) return
  isPasswordLoginLoading.value = true
  errors.username = ''
  errors.password = ''
  errors.agreement = ''
  showAgreementTooltip.value = false
  if (!agreeTerms.value) {
    showAgreementTooltip.value = true
    setTimeout(() => { showAgreementTooltip.value = false }, 3000)
    isPasswordLoginLoading.value = false
    return
  }
  if (!username.value) {
    errors.username = '请输入账号'
    isPasswordLoginLoading.value = false
    return
  }
  if (!password.value) {
    errors.password = '请输入密码'
    isPasswordLoginLoading.value = false
    return
  }
  try {
    const res = await loginByPassword({ username: username.value, password: password.value })
    if (res.code === 1) {
      setCookie(commonConfig.authTokenName, res.data.token, {
        path: '/',
        expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
      })
      let userInfo = {}
      try {
        const userInfoRes = await getUserInfoById(res.data.userId)
        if (userInfoRes.code === 1 && userInfoRes.data) {
          userInfo = userInfoRes.data
        }
      } catch (e) { }
      authStore.setAuth({ userId: res.data.userId, schoolId: res.data.schoolId, ...userInfo }, res.data.token)
      showToast('登录成功', 'success')
      setTimeout(() => { closeModal() }, 500)
    } else if (res.code === 1216) {
      showWeakPasswordModal.value = true
    } else {
      errors.password = res.message || '登录失败'
    }
  } catch (e) {
    errors.password = e?.response?.data?.message || '登录失败'
  } finally {
    isPasswordLoginLoading.value = false
  }
}


// 处理退出
const handleLogout = async () => {
  try {
    // 使用Pinia的clearAuth方法清除状态和Cookie
    authStore.clearAuth()
    showToast('已成功退出登录', 'success')
    // 新增：前端重定向到 /logout
    window.location.href = '/logout'
  } catch (error) {
    console.error('退出失败:', error)
    showToast('退出失败，请稍后重试', 'error')
  }
}

// 完善个人信息
const completeProfile = async () => {
  if (isCompleteProfileLoading.value) return
  isCompleteProfileLoading.value = true
  errors.nickname = ''
  errors.profilePassword = ''
  if (!profileData.nickname) {
    errors.nickname = '请输入您的昵称'
    isCompleteProfileLoading.value = false
    return
  }
  if (!profileData.password) {
    errors.profilePassword = '请输入密码'
    isCompleteProfileLoading.value = false
    return
  }
  if (profileData.password.length < 8 || profileData.password.length > 16) {
    errors.profilePassword = '密码长度应为8-16位'
    isCompleteProfileLoading.value = false
    return
  }
  try {
    // 优先用completeProfileToken
    const token = completeProfileToken.value || authStore.token || ''
    const fields = [
      { fieldName: 'nickName', fieldValue: profileData.nickname },
      { fieldName: 'password', fieldValue: profileData.password }
    ]
    const res = await fillRegisterInfo({ token, fields })
    if (res.code === 1) {
      let userInfo = {}
      try {
        const userInfoRes = await getUserInfoById(authStore.user?.userId)
        if (userInfoRes.code === 1 && userInfoRes.data) {
          userInfo = userInfoRes.data
        }
      } catch (e) { }
      if (userInfo && Object.keys(userInfo).length > 0) {
        authStore.setAuth({ ...authStore.user, ...userInfo }, token)
      }
      showToast('完善信息成功', 'success')
      setTimeout(() => { closeModal() }, 500)
    } else {
      errors.profilePassword = res.message || '完善信息失败'
    }
  } catch (e) {
    errors.profilePassword = e?.response?.data?.message || '完善信息失败'
  } finally {
    isCompleteProfileLoading.value = false
  }
}

const showAgreementModal = ref(false)
const agreementComponent = ref(null)
const agreementTitle = ref('')

const openAgreementModal = async (type) => {
  if (type === 'user') {
    agreementTitle.value = '使用协议'
    agreementComponent.value = defineAsyncComponent(() => import('./agreement.vue'))
  } else if (type === 'privacy') {
    agreementTitle.value = '隐私政策'
    agreementComponent.value = defineAsyncComponent(() => import('./privacy.vue'))
  }
  showAgreementModal.value = true
}
const closeAgreementModal = () => {
  showAgreementModal.value = false
}

// ==================== 生命周期 ====================

/**
 * 组件挂载时检查配置并强制更新按钮颜色
 */
onMounted(async () => {
  await nextTick()
  
  // 如果 window 中的配置有 headerMainColor，但 store 中没有，强制更新
  if (typeof window !== 'undefined' && window.__INITIAL_SITE_CONFIG__) {
    if (window.__INITIAL_SITE_CONFIG__.headerMainColor && !siteConfigStore.headerMainColor) {
      siteConfigStore.$patch({
        headerMainColor: window.__INITIAL_SITE_CONFIG__.headerMainColor
      })
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/variables/index' as vars;
@use '@/assets/styles/common/mixins' as mixins;
@use '@/assets/styles/common/responsive' as resp;

.my-component {
  // 移动端样式（默认）
  padding: vars.$ola-spacing-sm;

  // 平板及以上
  @include resp.ola-respond-above(sm) {
    padding: vars.$ola-spacing-md;
  }

  // 桌面及以上
  @include resp.ola-respond-above(lg) {
    padding: vars.$ola-spacing-lg;
  }
}

.login-container {
  display: flex;
  justify-content: flex-end;
  padding: vars.$ola-spacing-sm 0;
  position: relative;

  @include resp.ola-respond-below(sm) {
    justify-content: center;
    padding: vars.$ola-spacing-md 0;
  }
}

.login-wrapper {
  display: flex;
  align-items: center;
}

.user-login {
  display: flex;
  align-items: center;
   .avatar-img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      overflow: hidden;
    }
  .user-info {
    display: flex;
    align-items: center;

    .welcome {
      margin-right: 15px;
    }
   
  }

  a {
    margin-left: vars.$ola-spacing-md;
    color: #333;
    text-decoration: none;
    cursor: pointer;
    transition: color 0.3s ease;

    &:hover {
      color: var(--header-main-color, vars.$ola-primary);
    }
  }
}

.agreement-content {
  display: flex;
  align-items: center;
}

.welcome {

  @include resp.ola-respond-below(xs) {
    font-size: vars.$ola-font-size-xs;
  }

  color:#333;
}

.training-wrap {

  .welcome,
  .logout-btn {
    color: #fff;
  }
}

.logout-btn {
  color: var(--header-main-color, vars.$ola-primary);
  position: relative;

  .iconfont {
    font-size: 24px;
  }

  .login-drop {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 142px;
    height: 148px;
    .login-drop-inner {
      padding-top: 10px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-evenly;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      background-color: white;
      width: 142px;
      height: 148px;
      border-radius: 8px;
      background: #FFF;
      box-shadow: 0 0 5px #ddd;
    }
    .avatar-img{
      margin-right: 10px;
      width: 25px;
      height: 25px;
    }
    a {
      display: flex;
      align-items: center;
      margin-left: 0;
      font-size: 16px;
      height: 34px;
      line-height: 34px;
      color: #333;

      .iconfont {
        margin-right: 10px;
      }

      &:hover {
        color: var(--header-main-color, vars.$ola-primary);
      }
    }
  }

  &:hover {
    .login-drop {
      display: flex !important;
    }
  }
}

.login-btn,
.register-btn {
  padding: vars.$ola-spacing-xs vars.$ola-spacing-sm;

  @include resp.ola-respond-below(xs) {
    padding: calc(vars.$ola-spacing-xs / 2) vars.$ola-spacing-xs;
    font-size: vars.$ola-font-size-xs;
  }
}

/**
 * 登录/注册按钮颜色覆盖（根据站点配置）
 * - 默认：#FF1F59
 * - 德国站：#F93636
 */
.login-container :deep(.login-register-btn.ola-btn-primary),
.login-wrapper :deep(.login-register-btn.ola-btn-primary),
:deep(.login-register-btn.ola-btn-primary) {
  background-color: var(--login-button-color, #FF1F59) !important;
  border-color: var(--login-button-color, #FF1F59) !important;
  
  &:hover:not(:disabled) {
    background-color: var(--login-button-color, #FF1F59) !important;
    border-color: var(--login-button-color, #FF1F59) !important;
    opacity: 0.85;
  }
  
  &:active:not(:disabled) {
    background-color: var(--login-button-color, #FF1F59) !important;
    border-color: var(--login-button-color, #FF1F59) !important;
    opacity: 0.8;
  }
  
  &:focus {
    background-color: var(--login-button-color, #FF1F59) !important;
    border-color: var(--login-button-color, #FF1F59) !important;
  }
}

.btn-small {
  font-size: vars.$ola-font-size-xs;
  padding: calc(vars.$ola-spacing-xs / 2) vars.$ola-spacing-xs;
  background-color: vars.$ola-bg-light;
  border: 1px solid vars.$ola-border-base;
  border-radius: vars.$ola-radius-sm;
  cursor: pointer;
}

/* 登录模态框样式 */
.login-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.login-modal-content {
  background-color: #fff;
  border-radius: 8px;
  width: 540px;

  @media (max-width: 768px) {
    padding: 35px;
    max-width: 85%;
  }
   @media (max-width: 430px) {
    padding: 20px;
    max-width: 90%;
  }
  max-width: 90%;
  padding: 72px 72px 50px 72px;
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.close-btn {
  display: flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 15px;
  right: 18px;
  cursor: pointer;
  color: #999;
  font-size: 22px;
  z-index: 10;
  border-radius: 50%;
  .iconfont{
    font-size: 24px;
  }

}

.corner-icon {
  position: absolute;
  top: -5px;
  right: 0;
  font-size: 30px;
  cursor: default;
  color: var(--login-modal-primary-color, #FF1F59);

  &::after {
    position: absolute;
    content: '';
    display: block;
    width: 40px;
    height: 40px;
    background-color: #fff;
    transform-origin: center;
    transform: rotate(-52deg);
    top: 16px;
    left: -18px;
  }
}

.modal-title-content {
  margin-bottom: 30px;
  text-align: left;

  .modal-title {
    font-size: 24px;
    font-weight: 500;

    @media (max-width: 768px) {
      font-size: 22px;
    }

    color: #333;
  }

  .modal-sub-title-wrap {
    height: 20px;
  }

  .modal-sub-title {
    font-size: 14px;
    color: #999;

    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
}

.other-login {
  text-align: center;

  .other-login-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    font-size: 14px;

    @media (max-width: 768px) {
      font-size: 12px;
    }

    color: #aaa;

    &::before,
    &::after {
      content: '';
      display: inline-block;
      width: 32%;
      height: 1px;
      background-color: rgba(204, 204, 204, 0.80);;
    }
  }

  .iconfont {
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    font-size: 30px;

    @media (max-width: 768px) {
      width: 40px;
      height: 40px;
      font-size: 25px;
    }

    color: #09BB07;
    border: 1px solid #ddd;
  }
}

.tab-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  padding: 2px;
  width: 190px;
  height: 41px;
  border-radius: 8px;
  background: #F8F8F8;
}

.tab {
  cursor: pointer;
  position: relative;
  color: #666;
  font-size: 16px;

  text-align: center;
  display: flex;
  height: 36px;
  padding: 6px 10px;
  justify-content: center;
  align-items: center;

  &.active {
    color: #333;
    font-weight: 500;
    border-radius: 6px;
    font-size: 16px;
    background: #FFF;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
  }

  &:last-child {
    margin-right: 0;
  }

}

.login-form {
  margin-top: 20px;
}

.input-group {
  margin-bottom: 15px;
  position: relative;
  .flex-div {
    display: flex;
    align-items: center;
  }
  input {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #F8F8F8;
    border-radius: 4px;
    background-color: #F8F8F8;
    font-size: 16px;

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 1000px #F8F8F8 inset !important;
      transition: background-color 5000s ease-in-out 0s;
    }

    &::placeholder {
      color: rgba(0, 0, 0, 0.40);
    }

    &:focus {
      border-color: var(--login-modal-primary-color, #FF1F59);
      outline: none;

    }
  }

  .country-code {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 12px;
    // border-right: 1px solid #F8F8F8;

    .dropdown-icon {
      margin-left: 5px;
      font-size: 10px;
      color: #666;
    }
  }



  &.verification-code,
  &.pl10 {
    input {
      padding-left: 10px;
    }
  }
}

.verification-code {
  display: flex;

  input {
    flex: 1;
    border-radius: 4px 0 0 4px;
  }

  .verification-btn {
    padding: 0 15px;
    border: 1px solid #F8F8F8;
    background-color: #F8F8F8;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    white-space: nowrap;
    color: var(--login-modal-primary-color, #FF1F59);
    min-width: 110px;



    &:disabled {
      background-color: #f8f8f8;
      cursor: not-allowed;
      color: #666;
      border-radius: 0 4px 4px 0;
    }
  }
}

.login-tip {
  margin-bottom: 40px;
  font-size: 14px;
  color: #ccc;
}

.terms-agreement {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 28px;
  font-size: 14px;

  @media (max-width: 768px) {
    font-size: 12px;
  }

  color: #666;
  position: relative;

  input[type="checkbox"] {
    -webkit-appearance: none;
    appearance: none;
    position: relative;
    width: 14px;
    height: 14px;
    border: 1px solid #dcdfe6;
    border-radius: 2px;
    margin-right: 8px;
    cursor: pointer;
    vertical-align: middle;
    transition: all 0.2s;

    &:checked {
      background-color: var(--login-modal-primary-color, #FF1F59);
      border-color: var(--login-modal-primary-color, #FF1F59);

      &::after {
        content: '';
        position: absolute;
        left: 4px;
        top: 1px;
        width: 3px;
        height: 6px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
      }
    }
  }

  .term-link {
    color: var(--login-modal-primary-color, #FF1F59);
    text-decoration: none;
  }

  .forget-password {
    cursor: pointer;

    &:hover {
      color: var(--login-modal-primary-color, #FF1F59);
    }
  }

  .agreement-tooltip {
    position: absolute;
    bottom: -38px;
    left: 35%;
    transform: translateX(-50%);
    background-color: #7C8092;
    color: white;
    padding: 8px 12px;
    border-radius: 15px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 10;

    .tooltip-arrow {
      position: absolute;
      top: -11px;
      left: 70%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border: 6px solid #7C8092;
      border-color: transparent transparent #7C8092 transparent;
    }
  }
}

.login-submit {
  margin: 5px 0 20px 0;
  width: 100%;
  height: 48px;
  line-height: 48px;
  background-color: var(--login-modal-primary-color, #FF1F59);
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 18px;

  @media (max-width: 768px) {
    font-size: 16px;
    height: 43px;
    line-height: 43px;
  }

  &:hover:not(:disabled) {
    background-color: var(--login-modal-primary-color-hover, #E61A4F);
  }

  &:disabled {
    background-color: var(--login-modal-primary-color-disabled, rgba(255, 31, 89, 0.55));
    cursor: not-allowed;
  }
}

.register-hint {
  text-align: center;
  margin-top: 15px;
  font-size: 12px;
  color: #999;
}

.register-account {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  font-size: 14px;

  span {
    color: var(--login-modal-primary-color, #FF1F59);
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}

.toggle-password {
  position: absolute;
  right: 10px;
  color: #999;
  cursor: pointer;
  font-size: 14px;
}

/* 自定义提示框样式 */
.custom-toast {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px 20px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  z-index: 2000;
  min-width: 200px;
  max-width: 80%;

  &.info {
    background-color: #e6f7ff;
    border: 1px solid #91d5ff;
    color: #1890ff;
  }

  &.success {
    background-color: #f6ffed;
    border: 1px solid #b7eb8f;
    color: #52c41a;
  }

  &.error {
    background-color: #fff2f0;
    border: 1px solid #ffccc7;
    color: #ff4d4f;
  }

  .toast-icon {
    margin-right: 8px;
    font-weight: 500;
  }

  .toast-message {
    font-size: 14px;
  }
}

/* 提示框动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -20px);
}

/* 忘记密码步骤样式 */
.steps-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;

  .line {
    margin: 0 10px;
    width: 40px;
    height: 1px;
    background-color: #ddd;
  }
}

.step-item {
  display: flex;
  justify-content: center;
  position: relative;
  // flex: 1;

  &.active {
    .step-label {
      color: var(--login-modal-primary-color, #FF1F59);
      font-weight: 500;
    }
  }
}

.step-number {
  margin-right: 8px;
  width: 20px;
  height: 20px;
  line-height: 19px;
  border-radius: 50%;
  font-size: 12px;
  background-color: var(--login-modal-primary-color, #FF1F59);
  color: #fff;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 1;

  &.iconfont {
    background-color: var(--login-modal-primary-color-light-bg, rgba(255, 31, 89, 0.2));
    color: var(--login-modal-primary-color, #FF1F59);
  }
}

.step-label {
  font-size: 16px;

  @media (max-width: 768px) {
    font-size: 14px;
  }

  color: #666;

  &.second {
    color: #333;
  }
}

.error-message {
  color: #FF1612;
  font-size: 12px;
  margin-top: 4px;
  display: block;
  height: 18px;
  line-height: 18px;
}

.return-login {
  text-align: center;
  font-size: 14px;
  color: #999;
  cursor: pointer;
  margin-bottom: 20px;

  span {
    &:hover {
      color: var(--login-modal-primary-color, #FF1F59);
    }
  }
}

/* 协议弹窗样式 */
.agreement-modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.45);
  z-index: 2001;
  display: flex;
  align-items: center;
  justify-content: center;
}

.agreement-modal-content {
  background: #fff;
  border-radius: 8px;
  width: 520px;
  max-width: 90vw;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.agreement-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 24px 0 24px;
  font-size: 18px;
  font-weight: 500;
}

.agreement-modal-close {
  cursor: pointer;
  font-size: 22px;
  color: #999;
}

.agreement-modal-body {
  padding: 18px 24px 24px 24px;
  overflow-y: auto;
  font-size: 14px;
  color: #333;
  line-height: 1.7;
  white-space: pre-wrap;
}
.weak-password-modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.weak-password-modal-content {
  background-color: #fff;
  border-radius: 12px;
  width: 445px;
  max-width: 90%;
  padding: 40px 30px;
  position: relative;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);

  .close-btn {
    top: 15px;
    right: 15px;
  }

  .safe-icon {
    margin-bottom: 20px;
    img {
      width: 120px;
      height: auto;
    }
  }

  .safe-title {
    font-size: 22px;
    font-weight: 600;
    color: #333;
    margin-bottom: 20px;
  }

  .safe-desc {
    font-size: 15px;
    color: #666;
    line-height: 1.6;
    margin-bottom: 30px;
    padding: 0 10px;
    text-align: left;
  }

  .safe-btn {
    width: 258px;
    height: 50px;
    background-color: var(--login-modal-primary-color, #FF1F59);
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 18px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.3s, opacity 0.3s;

    &:hover {
      opacity: 0.9;
    }

    &:active {
      opacity: 0.8;
    }
  }
}
</style>
